import { render, staticRenderFns } from "./UserFolderItem.vue?vue&type=template&id=c9699982&"
import script from "./UserFolderItem.vue?vue&type=script&lang=js&"
export * from "./UserFolderItem.vue?vue&type=script&lang=js&"
import style0 from "./UserFolderItem.vue?vue&type=style&index=0&id=c9699982&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports